<ui-dialog
    formDialog
    [form]="kanbanUpdateColumnForm.form"
    (primaryButtonPressed)="onUpdateColumn(kanbanUpdateColumnForm.columnName)"
    (onSecondaryButtonPressed)="closeRenameModal()"
    size="small"
    [open]="isRenameModalOpen"
    header="{{ 'applicant-tracker.components.kanban.renameStage' | appTranslate }}"
    primaryButtonLabel="{{ 'save' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    (closing)="closeRenameModal()"
>
    <app-kanban-column-form #kanbanUpdateColumnForm [(columnName)]="temporaryColumnName"></app-kanban-column-form>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isDeleteModalOpen"
    [header]="
        !canDelete()
            ? 'applicant-tracker.components.kanban.unableToDeleteStage'
            : ('applicant-tracker.components.kanban.deleteStage' | appTranslate)
    "
    (closing)="closeDeleteModal()"
>
    <p *ngIf="!canDelete(); else allowDeleteion">
        {{ 'applicant-tracker.components.kanban.youCannotDeleteColumnsThatContainApplicants' | appTranslate }}
    </p>
    <ng-template #allowDeleteion>{{
        'applicant-tracker.components.kanban.areYouSureYouWantToDeleteThisColumn' | appTranslate
    }}</ng-template>
    <ui-dialog-footer>
        <ui-button *ngIf="!canDelete()" type="primary" (click)="closeDeleteModal()">{{
            'applicant-tracker.components.kanban.okay' | appTranslate
        }}</ui-button>

        <ui-button *ngIf="canDelete()" type="ghost" (click)="closeDeleteModal()">{{
            'cancel' | appTranslate
        }}</ui-button>
        <ui-button *ngIf="canDelete()" type="danger" (click)="onDeleteColumn()">{{
            'delete' | appTranslate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div
    class="kanban"
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="onColumnOrderChanged($event)"
    [cdkDropListSortPredicate]="sortPredicate"
    cdkDropList
>
    <div class="cdkGroupList flex" cdkDropListGroup role="list">
        <ui-card
            *ngFor="let column of columns; let first = first; let columnIndex = index"
            role="listitem"
            attr.aria-labelledby="column-header-{{ columnIndex }}"
            variant="dark"
            class="column"
            [cdkDragDisabled]="first"
            cdkDrag
        >
            <div class="column-placeholder" *cdkDragPlaceholder></div>
            <app-segment-header
                contextMenuType="material"
                id="column-header-{{ columnIndex }}"
                [title]="column.title | appTranslateOptions: jobFunnelNameDisplay"
                [contextMenu]="(allowColumnDeletion || allowColumnRename) && !first"
                [badgeOptions]="
                    column.data?.jobFunnelMessageTemplate || column.data?.funnelMessageTemplate
                        ? { label: 'applicant-tracker.components.kanban.auto-email', type: 'default' }
                        : null
                "
            >
                <button
                    mat-menu-item
                    *ngIf="isEmailAutomationForJobFunnel && !column.data?.jobFunnelMessageTemplate"
                    class="item"
                    [routerLink]="[column.data.id, 'jobFunnelMessageTemplate', 'create']"
                    (click)="trackAddEmailAutomationOnJobFunnelTemplate()"
                >
                    {{ 'applicant-tracker.components.kanban.addEmailAutomation' | appTranslate }}
                </button>
                <button
                    mat-menu-item
                    *ngIf="isEmailAutomationForJobFunnel && column.data?.jobFunnelMessageTemplate"
                    class="item"
                    [routerLink]="[
                        column.data.id,
                        'jobFunnelMessageTemplate',
                        'edit',
                        column.data?.jobFunnelMessageTemplate.id,
                    ]"
                    (click)="trackEditEmailAutomationOnJobFunnelTemplate()"
                >
                    {{ 'applicant-tracker.components.kanban.editEmailAutomation' | appTranslate }}
                </button>

                <button
                    mat-menu-item
                    *ngIf="isEmailAutomationForFunnelTemplateStage && !column.data?.funnelMessageTemplate"
                    class="item"
                    [routerLink]="['funnelTemplateStage', column.data.id, 'funnelMessageTemplate', 'create']"
                >
                    {{ 'applicant-tracker.components.kanban.addEmailAutomation' | appTranslate }}
                </button>
                <button
                    mat-menu-item
                    *ngIf="isEmailAutomationForFunnelTemplateStage && column.data?.funnelMessageTemplate"
                    class="item"
                    [routerLink]="[
                        'funnelTemplateStage',
                        column.data.id,
                        'funnelMessageTemplate',
                        'edit',
                        column.data?.funnelMessageTemplate.id,
                    ]"
                >
                    {{ 'applicant-tracker.components.kanban.editEmailAutomation' | appTranslate }}
                </button>

                <button mat-menu-item *ngIf="allowColumnRename" class="item" (click)="beforeUpdateColumn(column)">
                    {{ 'applicant-tracker.components.kanban.rename' | appTranslate }}
                </button>
                <button mat-menu-item (click)="beforeDeleteColumn(column)" class="item">
                    {{ 'applicant-tracker.components.kanban.delete' | appTranslate }}
                </button>
            </app-segment-header>

            <cdk-virtual-scroll-viewport
                [itemSize]="cardHeight"
                class="ui cards virtual"
                [cdkDropListData]="column.cards"
                cdkDropList
                (cdkDropListDropped)="onCardOrderChanged($event, columnIndex)"
                attr.aria-labelledby="column-header-{{ columnIndex }}"
                role="list"
            >
                <ui-card
                    *cdkVirtualFor="let card of column.cards; let cardIndex = index"
                    [routerLink]="['/recruiting/applicants', card.id]"
                    attr.aria-labelledby="applicant-header-{{ columnIndex }}-{{ cardIndex }}"
                    role="listitem"
                    class="ui card"
                    [attr.data-cy]="'card-' + cardIndex"
                    cdkDrag
                    [cdkDragData]="{ card: card, cardIndex: cardIndex }"
                    (cdkDragDropped)="onDropCard(card)"
                >
                    <div class="card-placeholder" *cdkDragPlaceholder></div>
                    <span>{{ card.data?.createdAt | appDate }}</span>

                    <h3 class="margin-top-1" id="applicant-header-{{ columnIndex }}-{{ cardIndex }}">
                        {{
                            card.data?.firstName + ' ' + card.data.lastName ||
                                'applicant-tracker.components.kanban.missing'
                        }}
                    </h3>
                    <div class="flex">
                        <ui-star-rating [currentValue]="card.data?.rating"></ui-star-rating>
                        <span class="paper-clip"><i class="fal fa-paperclip"></i> {{ card.contentCount }} </span>
                    </div>
                </ui-card>
            </cdk-virtual-scroll-viewport>
        </ui-card>
    </div>
</div>
